export class Settings {
    authenticationMethod: string;
    environmentId: number;
    isOnlineMode: boolean;
    manifestURL: string;
    proxyPrompt: boolean;
    solutionName: string;
}

export class AuthenticationConfig {
    authenticationMethod: string;
    otdsServerUrl: string;
    otdsResourceId: string;
    adminRoleGroup: string;
    Administrator: string;
}

export class AccountPolicy {
    lockoutDuration: number;
    lockoutThreshold: number;
}